var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.41 48.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #939598;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #007da5;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.21,
    cy: 24.21,
    r: 23.71
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.68,24.39c.82.86,1.76,1.55,2.87,1.94,2.9,1.01,5.48.44,7.72-1.64.3-.27.48-.25.77-.07,2.09,1.31,3,3.28,3.16,5.65.07,1.02.01,2.04.01,3.1H14.07c-.03-2.37-.23-4.74,1.18-6.84.62-.92,1.42-1.63,2.43-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.16,25.14c-3.2,0-5.79-2.57-5.8-5.76-.01-3.19,2.57-5.79,5.76-5.8,3.2,0,5.79,2.57,5.8,5.76,0,3.2-2.57,5.79-5.76,5.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8b5c0657ae26b7582f36034c0a7fc0ce.svg";
export { ForwardRef as ReactComponent };